// ABOUTME: Marks every modal's portal with the class that holds spark-ui's Preflight off the pages, which a
// ABOUTME: modal misses by portalling to the body rather than rendering inside them.

import ReactModal from "react-modal";

// Read once, so calling this more than once cannot stack the class up.
const ISOLATED_PORTAL_CLASS = `${ReactModal.defaultProps.portalClassName} ps-no-preflight`;

// Unmarked, spark-ui's Preflight reaches modal content and takes every property NDS leaves undeclared:
// inline icons turn into blocks, and the checkbox's ::before checkmark is measured as a border box, which
// leaves nothing of the borders it draws the tick from. Appended, since react-modal writes the portal's
// className outright. Inert on the legacy nav, which never loads spark-ui's stylesheet.
export default function isolateModalsFromSparkReset() {
  ReactModal.defaultProps.portalClassName = ISOLATED_PORTAL_CLASS;
}
